module.exports = __webpack_public_path__ + "img/wangzhan.46814774.png";